import { render } from "./QuizVaildate.vue?vue&type=template&id=1385d57a&scoped=true"
import script from "./QuizVaildate.vue?vue&type=script&lang=js"
export * from "./QuizVaildate.vue?vue&type=script&lang=js"

import "./QuizVaildate.vue?vue&type=style&index=0&id=1385d57a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1385d57a"]])

export default __exports__